
export default function Loader() {
  return (
    <div className="relative w-full h-[300px]">
        <div className="absolute inset-0 flex justify-center items-center">
        <div className="w-10 h-10 border-4 border-t-[#674936] border-gray-300 rounded-full animate-spin"></div>
        </div>
    </div>
  )
}
